// App.js
import React, { useEffect, useState } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import {
  Text,
  View,
  StyleSheet,
  ActivityIndicator,
  useWindowDimensions, // ✅ add
} from 'react-native';

// ⬇️ Your screens
import BusinessHomepage from './BusinessHomepage';
import CreateBrandListing from './CreateBrandListing';
import CreateBrandListingChoice from './CreateBrandListingChoice';
import QRCodeScannerPage from './QRCodeScannerPage';
import PotentialCollabsDashboard from './PotentialCollabsDashboard';
import ReviewCollabOfferForm from './ReviewCollabOfferForm';
import PostScanAdminRedeem from './PostScanAdminRedeem';
import SignUpPage from './SignUpPage';
import LogInPage from './LogInPage';
import BusinessAccountPage from './BusinessAccountPage';
import BrandListingsDashboard from './BrandListingsDashboard';
import ListingAssociatedCollabsDashboard from './ListingAssociatedCollabsDashboard';
import SingleCollabMetrics from './SingleCollabMetrics';
import TestQRCodeScannerPage from './TestQRCodeScannerPage';
import PasswordResetForm from './PasswordResetForm';
import SubmitChangedPassword from './SubmitChangedPassword';
import PostScanAdminRedeemCustomer from './PostScanAdminRedeemCustomer';
import PaymentPage from './PaymentPage';
import CollabCalendar from './CollabCalendar';
import collabbayAnalytics from './collabbayAnalytics';
import CampaignMetrics from './CampaignMetrics';
import InfluencerProfileAnalysis from './InfluencerProfileAnalysis';
import BrandCreateInviteLink from './BrandCreateInviteLink';
import EditOfferListing from './EditOfferListing';
import BrandActivityFeed from './BrandActivityFeed';
import InviteCollabbayCreator from './InviteCollabbayCreator';
import BrowseInviteCreators from './BrowseInviteCreators';
import GuidedOfferSetup from './GuidedOfferSetup';
import PostSuggestedListing from './PostSuggestedListing';
import MyPanel from './MyPanel';
import WelcomeOptions from './WelcomeOptions';
import ReviewDashboard from './ReviewDashboard';
import CreatorPreview from './CreatorPreview';
import BookingRequest from './BookingRequest';
import BookingTutorial from './BookingTutorial';
import RequestList from './RequestList';
import MyOffers from './MyOffers';
import CreatorOverview from './CreatorOverview';
import MyCalendar from './MyCalendar';
import BrowseCreators from './BrowseCreators';
import InviteCreator from './InviteCreator';
import MyActivityFeed from './MyActivityFeed';
import MyReviews from './MyReviews';

// ✅ NEW screen (EditMyListing)
import EditMyListing from './EditMyListing';

// ✅ Existing public screen
import PreviewBooking from './PreviewBooking';


import ContentBank from './ContentBank';

import BrandAIAnalysis from './BrandAIAnalysis';
import PublicBookingsAnalyticsDashboard from './PublicBookingsAnalyticsDashboard';

import AssignVouchers from './AssignVouchers';


const Stack = createStackNavigator();

// Optional flash message (not used right now but kept)
const FlashMessage = ({ message }) => (
  <View style={styles.flashMessageContainer}>
    <Text style={styles.flashMessageText}>{message}</Text>
  </View>
);

/**
 * 🔗 Linking config:
 * This is what makes /BookingRequest/123 → BookingRequest screen with { CollabID: "123" }
 */
const linking = {
  // URLs your app should handle
  prefixes: [
    'https://collabbayadmin.com',
    'https://www.collabbayadmin.com',
    'http://localhost:19006', // dev
  ],
  config: {
    screens: {
      // Root/home
      BusinessHomepage: '',

      // Auth
      SignUpPage: 'register',
      LogInPage: 'login',
      PasswordResetForm: 'PasswordReset',
      SubmitChangedPassword: 'ResetPassword/:token',

      BusinessAccountPage: 'account',

      // ✅ Public: Preview Booking (supports query params like ?CollabID=123&Promoter=abc)
      PreviewBooking: 'PreviewBooking',

      // ✅ NEW: EditMyListing (supports query params like ?ListingID=123)
      EditMyListing: 'EditMyListing',

      // Booking / collab screens
      BookingRequest: 'BookingRequest/:CollabID',
      RequestList: 'RequestList',
      CollabCalendar: 'CollabCalendar',
      MyCalendar: 'MyCalendar',

      // Listings / offers
      BrandListingsDashboard: 'BrandListingsDashboard',
      CreateBrandListing: 'CreateBrandListing',
      CreateBrandListingChoice: 'CreateBrandListingChoice',
      EditOfferListing: 'EditOfferListing/:ListingID?',
      MyOffers: 'MyOffers',

      // QR / Redeem flows
      QRCodeScannerPage: 'QRCodeScannerPage',
      PostScanAdminRedeem: 'PostScanAdminRedeem/:QRID',
      PostScanAdminRedeemCustomer: 'PostScanAdminRedeemCustomer/:CollabID',

      // Analytics / metrics
      collabbayAnalytics: 'Analytics',
      CampaignMetrics: 'CampaignMetrics',
      SingleCollabMetrics: 'SingleCollabMetrics/:CollabID?',
      InfluencerProfileAnalysis: 'InfluencerProfileAnalysis/:Username?',

      // Invites & creators
      BrowseInviteCreators: 'BrowseInviteCreators',
      InviteCollabbayCreator: 'InviteCollabbayCreator/:Username',
      BrowseCreators: 'BrowseCreators',
      InviteCreator: 'InviteCreator/:Username?',
      CreatorOverview: 'CreatorOverview/:Username?',
      CreatorPreview: 'CreatorPreview/:Username?',

      // Other dashboards / flows
      PotentialCollabsDashboard: 'PotentialCollabsDashboard',
      ReviewCollabOfferForm: 'ReviewCollabOfferForm/:CollabID?',
      PaymentPage: 'subscribe',
      BrandCreateInviteLink: 'BrandCreateInviteLink',
      BrandActivityFeed: 'BrandActivityFeed',
      MyActivityFeed: 'MyActivityFeed',
      MyReviews: 'MyReviews',
      TestQRCodeScannerPage: 'TestQRCodeScannerPage',
      GuidedOfferSetup: 'GuidedOfferSetup',
      PostSuggestedListing: 'PostSuggestedListing',
      MyPanel: 'MyPanel',
      WelcomeOptions: 'WelcomeOptions',
      ReviewDashboard: 'ReviewDashboard',
      ListingAssociatedCollabsDashboard:'ListingAssociatedCollabsDashboard/:ListingID?',
        ContentBank: 'ContentBank',
        BrandAIAnalysis: 'BrandAIAnalysis',
        PublicBookingsAnalyticsDashboard: 'PublicBookingsAnalyticsDashboard',
        AssignVouchers: 'AssignVouchers',


    },
  },
};

const AppContent = ({ authenticated, subscriptionAuthenticated }) => {
  // ✅ Responsive default homepage: desktop (>650px) shows MyPanel, mobile keeps BusinessHomepage
  const ResponsiveHomepage = (props) => {
    const { width } = useWindowDimensions();

    // If desktop AND authenticated, show MyPanel as the "/" landing view
    if (width > 650 && authenticated) {
      return <MyPanel {...props} />;
    }

    // Otherwise keep existing behaviour
    return <BusinessHomepage {...props} />;
  };

  return (
    <NavigationContainer
      linking={linking}
      fallback={
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color="#000" />
        </View>
      }
    >
      <Stack.Navigator
        initialRouteName="BusinessHomepage"
        screenOptions={{ headerShown: false }}
      >
        {/* Public screens */}
        <Stack.Screen
          name="BusinessHomepage"
          component={ResponsiveHomepage} // ✅ changed ONLY this
        />
        <Stack.Screen name="SignUpPage" component={SignUpPage} />
        <Stack.Screen name="LogInPage" component={LogInPage} />
        <Stack.Screen name="PasswordResetForm" component={PasswordResetForm} />
        <Stack.Screen
          name="SubmitChangedPassword"
          component={SubmitChangedPassword}
        />
        <Stack.Screen
          name="BusinessAccountPage"
          component={BusinessAccountPage}
        />

        {/* ✅ Public screen */}
        <Stack.Screen name="PreviewBooking" component={PreviewBooking} />

        {/* ✅ NEW: EditMyListing screen */}
        <Stack.Screen name="EditMyListing" component={EditMyListing} />

        {/* Authenticated-only screens */}
        {authenticated && (
          <>
            <Stack.Screen name="CollabCalendar" component={CollabCalendar} />
            <Stack.Screen
              name="QRCodeScannerPage"
              component={QRCodeScannerPage}
            />
            <Stack.Screen
              name="BrandListingsDashboard"
              component={BrandListingsDashboard}
            />
            <Stack.Screen
              name="ListingAssociatedCollabsDashboard"
              component={ListingAssociatedCollabsDashboard}
            />
            <Stack.Screen
              name="SingleCollabMetrics"
              component={SingleCollabMetrics}
            />
            <Stack.Screen
              name="TestQRCodeScannerPage"
              component={TestQRCodeScannerPage}
            />
            <Stack.Screen
              name="CreateBrandListing"
              component={CreateBrandListing}
            />
            <Stack.Screen
              name="CreateBrandListingChoice"
              component={CreateBrandListingChoice}
            />
            <Stack.Screen
              name="PotentialCollabsDashboard"
              component={PotentialCollabsDashboard}
            />
            <Stack.Screen
              name="ReviewCollabOfferForm"
              component={ReviewCollabOfferForm}
            />
            <Stack.Screen
              name="PostScanAdminRedeem"
              component={PostScanAdminRedeem}
            />
            <Stack.Screen
              name="PostScanAdminRedeemCustomer"
              component={PostScanAdminRedeemCustomer}
            />
            <Stack.Screen name="PaymentPage" component={PaymentPage} />
            <Stack.Screen
              name="collabbayAnalytics"
              component={collabbayAnalytics}
            />  
           <Stack.Screen name
           ="AssignVouchers" component={AssignVouchers} 
           />
            <Stack.Screen
              name="CampaignMetrics"
              component={CampaignMetrics}
            />
            <Stack.Screen
              name="InfluencerProfileAnalysis"
              component={InfluencerProfileAnalysis}
            />
            <Stack.Screen
              name="BrandCreateInviteLink"
              component={BrandCreateInviteLink}
            />
            <Stack.Screen
              name="EditOfferListing"
              component={EditOfferListing}
            />
            <Stack.Screen
              name="BrandActivityFeed"
              component={BrandActivityFeed}
            />
            <Stack.Screen name="MyActivityFeed" component={MyActivityFeed} />
            <Stack.Screen name="MyReviews" component={MyReviews} />
            <Stack.Screen
              name="BrowseInviteCreators"
              component={BrowseInviteCreators}
            />
            <Stack.Screen
              name="InviteCollabbayCreator"
              component={InviteCollabbayCreator}
            />
            <Stack.Screen
              name="GuidedOfferSetup"
              component={GuidedOfferSetup}
            />
            <Stack.Screen
  name="PostSuggestedListing"
  component={PostSuggestedListing}
/>
            <Stack.Screen name="MyPanel" component={MyPanel} />
            <Stack.Screen name="WelcomeOptions" component={WelcomeOptions} />
            <Stack.Screen name="ReviewDashboard" component={ReviewDashboard} />
            <Stack.Screen name="CreatorPreview" component={CreatorPreview} />
<Stack.Screen
  name="BookingRequest"
  component={BookingRequest}
  getId={({ params }) =>
    params?.CollabID ? `BookingRequest-${params.CollabID}` : undefined
  }
/>

<Stack.Screen
  name="BookingTutorial"
  component={BookingTutorial}
/>
            <Stack.Screen name="RequestList" component={RequestList} />
            <Stack.Screen name="MyOffers" component={MyOffers} />
            <Stack.Screen name="CreatorOverview" component={CreatorOverview} />
            <Stack.Screen name="MyCalendar" component={MyCalendar} />
            <Stack.Screen name="BrowseCreators" component={BrowseCreators} />
            <Stack.Screen name="InviteCreator" component={InviteCreator} />

<Stack.Screen name="ContentBank" component={ContentBank} />

<Stack.Screen name="BrandAIAnalysis" component={BrandAIAnalysis} />

<Stack.Screen
  name="PublicBookingsAnalyticsDashboard"
  component={PublicBookingsAnalyticsDashboard}
/>

          </>
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
};





const App = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [subscriptionAuthenticated, setSubscriptionAuthenticated] =
    useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  /*
   * ============================================================
   * MAGIC BOOKING LINK
   * ============================================================
   *
   * Expected URL:
   *
   * /BookingRequest/COLLABID?token=TOKEN
   *
   * This function ONLY reads the token.
   * It does not authenticate anybody by itself.
   */
  const getMagicBookingLinkFromUrl = () => {
    if (typeof window === 'undefined') {
      return null;
    }

    try {
      const url = new URL(window.location.href);

      const token = url.searchParams.get('token');

      if (!token) {
        return null;
      }

      /*
       * Only allow token login on the BookingRequest route.
       *
       * Example:
       * /BookingRequest/COLL1234ABCD
       */
      const match = url.pathname.match(
        /^\/BookingRequest\/([^/]+)\/?$/
      );

      if (!match || !match[1]) {
        return null;
      }

      return {
        CollabID: decodeURIComponent(match[1]),
        CollabToken: token,
      };
    } catch (error) {
      console.error(
        'Unable to parse magic booking URL:',
        error
      );

      return null;
    }
  };

  /*
   * Remove the secret token from the visible browser URL
   * WITHOUT refreshing the page.
   *
   * Before:
   * /BookingRequest/ABC?token=SECRET
   *
   * After:
   * /BookingRequest/ABC
   */



const routeMagicBookingForDevice = (collabID) => {
  if (
    typeof window === 'undefined' ||
    !window.history ||
    !window.history.replaceState
  ) {
    return;
  }

  try {
    const isMobile = window.innerWidth <= 650;

    const cleanCollabID = encodeURIComponent(collabID);

    const destination = isMobile
      ? `/SingleCollabMetrics/${cleanCollabID}`
      : `/BookingRequest/${cleanCollabID}`;

    window.history.replaceState(
      {},
      document.title,
      destination
    );
  } catch (error) {
    console.error(
      'Unable to route booking for device:',
      error
    );
  }
};

  /*
   * Send CollabID + token to the PHP verifier.
   *
   * The PHP:
   * - checks CollabID
   * - checks token
   * - checks 72-hour expiry
   * - finds BrandName
   * - finds real users row
   * - creates PHP session
   * - removes CollabToken
   */
  const verifyMagicBookingLink = async (
    magicLink
  ) => {
    try {
      const response = await fetch(
        'https://collabbayadmin.com/APIControllers/VerifyCollabToken.php',
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            CollabID: magicLink.CollabID,
            CollabToken:
              magicLink.CollabToken,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        console.error(
          'Magic booking verification failed:',
          data.message
        );

        return false;
      }

      return true;
    } catch (error) {
      console.error(
        'Error verifying magic booking link:',
        error
      );

      return false;
    }
  };

  /*
   * ============================================================
   * EXISTING AUTH CHECK
   * ============================================================
   *
   * Same existing endpoint.
   *
   * Difference:
   * this now RETURNS true/false as well as updating state.
   */
  const checkAuthentication = async () => {
    try {
      const response = await fetch(
        'https://collabbayadmin.com/APIControllers/UserAuthSession.php',
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type':
              'application/json',
          },
        }
      );

      const data = await response.json();

      if (data.authenticated) {
        setAuthenticated(true);
        setError(null);

        return true;
      }

      setAuthenticated(false);
      setError('Log in required');

      return false;
    } catch (error) {
      console.error(
        'Error checking authentication:',
        error
      );

      setAuthenticated(false);

      setError(
        'An error occurred. Please try again later.'
      );

      return false;
    }
  };

  /*
   * Existing subscription authentication.
   *
   * credentials: 'include' added so it definitely sees
   * the session created by VerifyCollabToken.php.
   */
  const checkSubscriptionAuthentication =
    async () => {
      try {
        const response = await fetch(
          'https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php',
          {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type':
                'application/json',
            },
          }
        );

        const subscriptionData =
          await response.json();

        setSubscriptionAuthenticated(
          subscriptionData.authenticated
        );
      } catch (error) {
        console.error(
          'Error checking subscription authentication:',
          error
        );

        setError(
          'An error occurred while checking subscription.'
        );
      }
    };

  /*
   * ============================================================
   * APP STARTUP
   * ============================================================
   *
   * FLOW:
   *
   * 1. Check normal session.
   *
   * 2. If already logged in:
   *    DO NOT verify/use CollabToken.
   *
   * 3. If not logged in and URL has token:
   *    VerifyCollabToken.php.
   *
   * 4. PHP creates session.
   *
   * 5. Check normal UserAuthSession.php again.
   *
   * 6. authenticated becomes true.
   *
   * 7. Existing private BookingRequest screen becomes available.
   */
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      try {
        /*
         * First respect the ordinary existing session.
         */
        let isAlreadyAuthenticated =
          await checkAuthentication();

        /*
         * Check whether this browser URL contains
         * a BookingRequest magic token.
         */
        const magicLink =
          getMagicBookingLinkFromUrl();

        /*
         * ONLY use the token if there is currently
         * no authenticated session.
         */
        if (
          !isAlreadyAuthenticated &&
          magicLink
        ) {
          const verified =
            await verifyMagicBookingLink(
              magicLink
            );

          if (verified) {
            /*
             * PHP has now:
             * - created session
             * - consumed CollabToken
             *
             * Remove secret token from browser URL.
             */

            routeMagicBookingForDevice(
  magicLink.CollabID
);

            /*
             * Confirm that the newly-created PHP session
             * works through your normal authentication endpoint.
             */
            isAlreadyAuthenticated =
              await checkAuthentication();
          }
        } else if (
          isAlreadyAuthenticated &&
          magicLink
        ) {
          /*
           * IMPORTANT:
           *
           * User is already logged in.
           *
           * Do NOT call VerifyCollabToken.php.
           * Do NOT consume token.
           *
           * The ordinary logged-in flow wins.
           *
           * We only remove the secret from the visible URL.
           */
          routeMagicBookingForDevice(
  magicLink.CollabID
);
        }

        /*
         * Run existing subscription/auth-mode logic
         * only after any possible magic login has completed.
         */
        await checkSubscriptionAuthentication();

      } catch (err) {
        console.error(
          'Error during loading:',
          err
        );
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  /*
   * Keep the existing loading screen.
   *
   * This is important because NavigationContainer should NOT
   * attempt to resolve /BookingRequest/:CollabID before
   * magic-token authentication has finished.
   */
  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator
          size="large"
          color="#000"
        />
      </View>
    );
  }

  return (
    <AppContent
      authenticated={authenticated}
      subscriptionAuthenticated={
        subscriptionAuthenticated
      }
    />
  );
};









const styles = StyleSheet.create({
  flashMessageContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'yellow',
    padding: 10,
  },
  flashMessageText: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
});

export default App;
